﻿// ControleSaisieCbSumUp.js
// Equivalent de ton controle jQuery "dxCtrlSaisieCb" (Stripe), mais pour SumUp.
// Meme structure, memes noms de fonctions/options que ta version Stripe, pour
// que ton code appelant n'ait presque rien a changer.
//
// PRE-REQUIS SUR LA PAGE : charger le script SumUp AVANT ce fichier, une fois
// dans ta page (comme le script Stripe l'est deja probablement) :
//   <script src="https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js"></script>
//
// 3DS : gere par le widget SumUp lui-meme (evenement "auth-screen"), rien a
// construire cote client. Cote serveur, penser a renseigner "redirect_url"
// (recommande par SumUp pour les cartes soumises au 3DS) et "return_url"
// (notification serveur si le client ferme l'onglet apres le 3DS) lors de la
// creation du checkout dans "getcbcheckoutsumup".
$.fn.dxCtrlSaisieCbSumUp = function custom_dxCtrlSaisieCbSumUp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisiecbsumup");
        this.instance = new cdxCtrlSaisieCbSumUp(this, option);
    }
    return this;
}
window.cdxCtrlSaisieCbSumUp = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    // Verification du statut apres "success" : un checkout peut rester PENDING
    // quelques secondes apres le 3DS. On re-interroge avant de conclure a un
    // echec (sinon le client pourrait repayer alors que le 1er paiement passe).
    var NB_ESSAIS_PENDING = 5
    var DELAI_ESSAI_PENDING_MS = 2000

    // Chez Stripe : "stripe" (objet Stripe) + "elements".
    // Chez SumUp : un seul objet retourne par SumUpCard.mount(), qui expose
    // submit() / unmount() / update(). C'est lui qui remplace "elements".
    var sumupCard = null;
    var $DivButtonPayer = null;

    // Branche (ou re-branche) le clic du bouton sur le VRAI paiement.
    // Extrait dans une fonction a part pour pouvoir re-brancher ce comportement
    // normal apres un refresh de checkout reussi (voir mRafraichirCheckoutPuisReafficher).
    function mBindClickPayer() {
        $DivButtonPayer.off("click").on("click", function (e) {
            e.preventDefault();
            if (sumupCard == null || $DivButtonPayer.is(":hidden")) return; // garde-fou anti double-clic
            $DivButtonPayer.hide();
            jaugeDemarrage.mShow()
            sumupCard.submit();
        });
    }

    function mLibellePayer() {
        $("#button-text").html("Payer <b>" + (option.amount100 / 100).round().formatDisplay() + "€</b>")
    }

    function mConstruit() {
        container.empty()
        container.css("max-width", "450px")
        var containerForm = $("<form id='payment-form-sumup'/>").appendTo(container)
        var $DivInformation = $('<div id="information"></div>').appendTo(containerForm)
        // Chez Stripe : <div id="payment-element"> monte les champs de carte.
        // Chez SumUp : <div id="sumup-card"> est le conteneur ou le widget SumUp
        // va s'afficher (SumUpCard.mount cible cet id par defaut).
        var $DivPaiementElement = $('<div id="sumup-card"></div>').appendTo($DivInformation)
        // On garde EXACTEMENT le meme principe que Stripe : c'est TON bouton,
        // pas celui fourni par defaut par SumUp (showSubmitButton: false plus bas).
        // type="button" est important : on ne veut pas d'un vrai submit HTML,
        // c'est nous qui declenchons sumupCard.submit() manuellement.
        $DivButtonPayer = $('<button type="button" id="submit" class="buttonstripe">').appendTo(containerForm)
        $('<div class="spinner hidden" id="spinner"></div>').appendTo($DivButtonPayer)
        $('<span id="button-text">Payer</span>').appendTo($DivButtonPayer)
        $('<div id="payment-message" class="hidden"></div>').appendTo(containerForm)
        // Chez Stripe : mGetPayementIntent recupere client_secret + cle publique.
        // Chez SumUp : mGetCheckout recupere juste un checkoutId (pas de cle
        // publique cote client, SumUp n'en a pas besoin).
        mGetCheckout(function (data) {
            mLibellePayer()

            sumupCard = SumUpCard.mount({
                id: "sumup-card",
                checkoutId: data.checkout_id,
                showSubmitButton: false,   // equivalent : on garde notre bouton comme avec Stripe
                showFooter: true,          // laisse "Powered by SumUp" (verifie ton contrat SumUp)
                showInstallments: false,   // deja par defaut, mais explicite = un champ en moins
                showZipCode: false,        // idem, un champ en moins si pas requis pour ta devise
                showEmail: false,          // idem
                locale: "fr-FR",
                onLoad: function () {
                    // Equivalent du timeout d'affichage que tu avais avec Stripe.
                    window.setTimeout(function () {
                        $("#payment-form-sumup").animate({ opacity: 1 }, 400, function () {
                            if (typeof option.onContentReady != 'undefined') option.onContentReady()
                        })
                    }, 200)
                },
                onResponse: handleResponse
            });

            mBindClickPayer();
        })
    }
    this.mClickButtonPayer = function () {
        $DivButtonPayer.trigger("click")
    }

    // Le checkout precedent est mort (echec, annulation, timeout, refus) -- on
    // en cree un NOUVEAU cote serveur et on rebranche le widget dessus AVANT de
    // redonner la main a l'utilisateur (sinon un nouveau clic "Payer" retenterait
    // sur un checkout deja invalide et echouerait systematiquement).
    // Si meme la creation du nouveau checkout echoue (ex: probleme reseau a ce
    // moment precis), on ne redonne PAS acces au vrai paiement : le bouton
    // devient "Reessayer" et relance uniquement cette preparation.
    // IMPORTANT cote serveur : "getcbcheckoutsumup" doit enregistrer ce NOUVEAU
    // checkout_id comme checkout courant de la commande, car
    // "confirmcbcheckoutsumup" interroge le dernier checkout connu.
    function mRafraichirCheckoutPuisReafficher() {
        var nouveauCheckoutObtenu = false

        mGetCheckout(function (data) {
            sumupCard.update({ checkoutId: data.checkout_id })
            nouveauCheckoutObtenu = true
        }, function () {
            jaugeDemarrage.mHide()

            if (nouveauCheckoutObtenu) {
                // Nouveau checkout pret : retour a l'etat normal.
                mLibellePayer()
                mBindClickPayer();
                $DivButtonPayer.show()
            } else {
                // Echec de la preparation : on bloque le vrai paiement et on
                // propose seulement de reessayer la preparation elle-meme.
                $("#button-text").text("Réessayer")
                $DivButtonPayer.off("click").on("click", function (e) {
                    e.preventDefault();
                    $DivButtonPayer.hide();
                    jaugeDemarrage.mShow()
                    mRafraichirCheckoutPuisReafficher();
                });
                $DivButtonPayer.show()
                mNotify("Impossible de préparer un nouveau paiement pour le moment.<br/>Veuillez réessayer ultérieurement.", "error", 6000)
            }
        })
    }

    // Verifie le statut reel du paiement cote serveur, en re-essayant tant
    // qu'il est PENDING (typiquement juste apres un 3DS).
    function mAttendrePaiement(essai) {
        mConfirmCheckout(function (data) {
            if (data.status == "PAID") {
                jaugeDemarrage.mHide()
                option.onValidePaiement(option.amount100, data)
                // Pas de reaffichage : paiement termine.
            }
            else if (data.status == "PENDING" && essai < NB_ESSAIS_PENDING) {
                window.setTimeout(function () { mAttendrePaiement(essai + 1) }, DELAI_ESSAI_PENDING_MS)
            }
            else if (data.status == "PENDING") {
                // Toujours en attente apres tous les essais : on NE recree PAS de
                // checkout (le paiement peut encore aboutir -> risque de double
                // debit). On previent le client ; la validation definitive se fera
                // cote serveur via la notification SumUp (return_url).
                jaugeDemarrage.mHide()
                mSaveError(JSON.stringify({ type: "success", status: data.status, essais: essai }))
                mNotify("Votre paiement est en cours de validation par votre banque.<br/>Merci de ne pas repayer, vous serez informé de sa confirmation.", "warning", 10000)
                if (typeof option.onPaiementEnAttente != 'undefined') option.onPaiementEnAttente(option.amount100, data)
            }
            else {
                // Checkout mort (FAILED/EXPIRED...) -> on en refait un neuf avant
                // de redonner la main, sinon retenter echouerait systematiquement.
                mSaveError(JSON.stringify({ type: "success", status: data.status }))
                mNotify("Paiement non confirmé (" + data.status + ").<br/>Veuillez réessayer ultérieurement.", "error", 6000)
                mRafraichirCheckoutPuisReafficher()
            }
        })
    }

    function handleResponse(type, body) {
        switch (type) {
            case "auth-screen":
                // Le widget affiche l'ecran d'authentification 3DS de la banque.
                // On masque la jauge (affichee depuis le clic sur "Payer") pour
                // qu'elle ne recouvre pas cet ecran : le client doit pouvoir
                // saisir son code / valider dans son appli bancaire.
                jaugeDemarrage.mHide()
                break

            case "success":
                // ATTENTION (specifique a SumUp, n'existe pas chez Stripe) :
                // "success" ici veut dire "le formulaire a ete traite", PAS
                // forcement "le paiement a reussi". Il FAUT reverifier cote
                // serveur avant de valider quoi que ce soit.
                jaugeDemarrage.mShow()
                mAttendrePaiement(0)
                break

            case "fail":
                // Equivalent de result.error chez Stripe : la doc SumUp precise
                // que ca arrive quand l'utilisateur annule le formulaire ou que
                // la session a expire -- dans les 2 cas le checkout devient mort,
                // on en refait un neuf avant de redonner la main.
                mSaveError(JSON.stringify({ type: type, body: body }))
                mNotify("Le paiement a échoué ou a été annulé.", "error", 6000)
                jaugeDemarrage.mShow()
                mRafraichirCheckoutPuisReafficher()
                break

            case "invalid":
                // Champs de carte invalides (numero, date, cvv...) : rien n'a ete
                // envoye a SumUp, le checkout est intact, pas besoin d'un nouveau.
                $DivButtonPayer.show()
                jaugeDemarrage.mHide()
                mNotify("Merci de vérifier les informations de votre carte.", "error", 6000)
                break

            case "error":
                // Equivalent du "loaderror" Stripe (ex: carte refusee, fonds
                // insuffisants, probleme de configuration) : checkout probablement
                // mort aussi, on en refait un neuf avant de redonner la main.
                mSaveError(JSON.stringify({ type: type, body: body }))
                if (typeof option.onLoadError != 'undefined') option.onLoadError()
                jaugeDemarrage.mShow()
                mRafraichirCheckoutPuisReafficher()
                break

            case "sent":
                // Formulaire envoye au serveur SumUp, en attente de reponse.
                break
        }
    }

    // Chez Stripe : appelle ta commande serveur existante "getcbpaiementintentclient".
    // Chez SumUp : appelle une NOUVELLE commande a creer cote serveur, qui cree
    // un checkout SumUp et renvoie juste { checkout_id: "..." }.
    // funcAlways (optionnel) s'execute que la commande reussisse ou echoue --
    // utilise par mRafraichirCheckoutPuisReafficher pour savoir dans tous les
    // cas quand reprendre la main sur le bouton/spinner.
    function mGetCheckout(funcOk, funcAlways) {
        option.bddCtrl.mAjaxCall({
            command: "getcbcheckoutsumup",
            id_table: option.id_table,
            id: option.id,
            id_societe: option.id_societe,
            amount100: option.amount100
        }, function (data) {
            if (typeof data.text_erreur != 'undefined') {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement(data.text_erreur)
            } else {
                funcOk(data) // data.checkout_id attendu
            }
        },
            function () { if (typeof funcAlways != 'undefined') funcAlways() },
            function (a, b, c, d) {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement("")
                if (typeof funcAlways != 'undefined') funcAlways()
            })
    }

    // NOUVEAU par rapport a Stripe : verification finale cote serveur.
    // Appelle une NOUVELLE commande serveur qui revient interroger SumUp pour
    // avoir le VRAI statut du paiement (PAID, FAILED, PENDING...).
    // Le verrou est libere dans TOUS les cas (succes ET erreur), sinon les
    // re-essais PENDING seraient ignores.
    var inCallConfirmCheckOut = false
    function mConfirmCheckout(funcOk) {
        if (inCallConfirmCheckOut) return
        inCallConfirmCheckOut = true
        option.bddCtrl.mAjaxCall({
            command: "confirmcbcheckoutsumup",
            id_table: option.id_table,
            id: option.id,
            id_societe: option.id_societe
        }, function (data) {
            inCallConfirmCheckOut = false
            funcOk(data) // data.status attendu
        },
            function () { inCallConfirmCheckOut = false },
            function (a, b, c, d) {
                inCallConfirmCheckOut = false
                jaugeDemarrage.mHide()
                // Statut inconnu (erreur reseau/serveur) : on ne recree PAS de
                // checkout, le paiement a peut-etre abouti.
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement("")
            })
    }

    function mSaveError(dataError) {
        try {
            option.bddCtrl.mAjaxCall({ command: "saveerrorcb", dataError: dataError, stacktrace: mGetStackTrace() }, function (data) { })
        }
        catch (e) { }
        try {
            throw new Error("Erreur cb SUMUP (" + JSON.stringify(dataError) + ")");
        } catch (e) {
            mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
        }
    }

    this.element = function () { return container }
    mConstruit();
}